<template>
  <div class="breadcrumb-wrapper">
    <div class="progress-bar">
      <div class="line"></div>
      <div class="dots">
        <div class="dot" :class="{'active': isCurrentStep(1), 'completed': isStepCompleted(1)}"></div>
        <div class="dot" :class="{'active': isCurrentStep(2), 'completed': isStepCompleted(2)}"></div>
        <div class="dot" :class="{'active': isCurrentStep(3)}"></div>
      </div>
    </div>
    <ul class="breadcrumb">
      <li class="breadcrumb-item" :class="{'active': isCurrentStep(1), 'completed': isStepCompleted(1)}">Wybór produktu</li>
      <li class="breadcrumb-item" :class="{'active': isCurrentStep(2), 'completed': isStepCompleted(2)}">Wartość kodu</li>
      <li class="breadcrumb-item" :class="{'active': isCurrentStep(3)}">Podsumowanie i&nbsp;płatność</li>
    </ul>
  </div>
</template>

<script>
import ProgressMixin from '@/common/mixins/Voucher/Progress.mixin'

export default {
  name: 'TopupCodesBreadcrumbs',
  mixins: [ProgressMixin]
}
</script>
